import {
    TERMS_LOADED_SUCCESSFULLY,
    TERMS_OPENED,
    TERMS_ACCEPTED,
    TERMS_NOT_ACCEPTED,
  } from "../actions/type";
  
  const user = localStorage.getItem("auth");
  
  const initialState = {
      viewInstance: null,
      isOpen: false,
      isAccepted: true,
      viewInstanceGuid: null
  }
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case TERMS_LOADED_SUCCESSFULLY:
        return {
          ...state,
          viewInstance: payload
        };  
      case TERMS_OPENED:
        return {
          ...state,
          isOpen: true
        };
      case TERMS_ACCEPTED:
        return {
          ...state,
          isOpen: false,
          isAccepted: true
        };
      case TERMS_NOT_ACCEPTED:
        return {
          ...state,
          isOpen: false,
          isAccepted: false
        };
      default:
        return state;
    }
  }